import Vue from 'vue';
import App from './App';
import routes from './router';
import Router from 'vue-router';
import {get,post} from '../store/vue_resource';
import {hasBtn,getBtnStatus,removeByIndex,getTime,getTime_us,getTime_us_f,getTime_zone,isMobile,getTime_week,week_f,unique1,price_discount,parseTime,detectZoom,getTime_week_} from '../store/store';

import Swiper from 'swiper';
import 'swiper/css/swiper.css';

import ("@/assets/css/wangeditor.css");
if (isMobile()) {
	import("@/assets/css/wapstyle.css");
	import("@/assets/js/font.js");
}else{
	import("@/assets/css/style.css");
	detectZoom();
}
 import preview from 'vue-photo-preview'
 import 'vue-photo-preview/dist/skin.css'
 Vue.use(preview)


import ElementUI from 'element-ui';
import GeminiScrollbar from 'vue-gemini-scrollbar';
import 'element-ui/lib/theme-chalk/index.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueResource from 'vue-resource';
import { Loading } from 'element-ui';
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$getBtnStatus = getBtnStatus;
Vue.prototype.hasBtn = hasBtn;
Vue.prototype.removeByIndex = removeByIndex;
Vue.prototype.getTime = getTime;
Vue.prototype.getTime_us = getTime_us;
Vue.prototype.getTime_us_f = getTime_us_f;
Vue.prototype.getTime_zone = getTime_zone;
Vue.prototype.getTime_week = getTime_week;
Vue.prototype.getTime_week_ = getTime_week_;
Vue.prototype.unique1 = unique1;
Vue.prototype.week_f = week_f;
Vue.prototype.price_discount = price_discount;
Vue.prototype.parseTime = parseTime;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueResource);

Vue.use(GeminiScrollbar);

import i18n from './i18n/i18n';
var lang = localStorage.getItem('lang') || 'en';
i18n.locale = lang;
Vue.prototype.lang = lang;

const router = new Router({
	mode: 'history',
	routes
})
router.beforeEach((to, from, next) => {
	const hash = window.location.hash;
	if (hash && hash.startsWith('#/')) {
		const targetPath = hash.slice(1)
		if (to.fullPath === targetPath) {
			return next()
		}
		return next({ path: targetPath, replace: true })
	}

	if (to.path == '/index_login' || to.path == '/login') {
		localStorage.removeItem('TokenId');
		localStorage.removeItem('user_name');
		localStorage.removeItem('shop_num');
	}
	var TokenId = localStorage.getItem('TokenId') || '';
	var path_array=['/','/course_index','/course_search','/course_camps','/course_info','/payment_results','/forgot_password_reset','/index_forgot_password_reset','/course_camps_info','/news_index','/news_videos','/news_info','/teachers_index','/teachers_info','/footer_about','/index_login','/login','/footer_faq','/footer_terms','/footer_team','/footer_teacher_apply','/footer_contact','/index_register','/index_forgot_password','/course_competition','/course_private','/course_private_info','/course_activity','/course_activity_info','/footer_privacy'];
	console.log(TokenId)
	if(!TokenId&&path_array.indexOf(to.path)==-1){
		next({path: '/index_login?redirect='+to.fullPath})
	}else if(TokenId){
		var expire_timestamp  = localStorage.getItem('expire_timestamp');
		var timestamp = Math.round(new Date().getTime()/1000);
		var expire = 1*60*60;
		if(expire_timestamp&&timestamp-expire_timestamp<expire){
			localStorage.setItem('expire_timestamp',timestamp);
			next();
		}else{
			localStorage.removeItem('TokenId');
			localStorage.removeItem('user_name');
			localStorage.removeItem('shop_num');
			if(path_array.indexOf(to.path)==-1){
				next({path: '/index_login?redirect='+to.fullPath})
			}else{
				next();
			}
		}
	}else{
		next();
	}
})
new Vue({
	el: '#app',
	i18n,
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js